import React from 'react';
import SafeIcon from '../common/SafeIcon';
import ImageWithFallback from './ImageWithFallback';
import SponsorshipCTA from './SponsorshipCTA';
import * as FiIcons from 'react-icons/fi';

const { FiHeart, FiExternalLink } = FiIcons;

const PlayerSponsorBlock = ({ player, compact = false, sourceLocation = 'player' }) => {
  if (!player) return null;

  const hasSponsor = Boolean(player.sponsor_image_url || player.sponsor_name);
  const sponsorContent = (
    <div
      className={`group flex items-center gap-3 rounded-xl border border-primary-100 bg-white p-3 transition ${
        player.sponsor_url ? 'hover:border-primary-300 hover:shadow-md' : ''
      }`}
    >
      <div className={`${compact ? 'h-12 w-20' : 'h-14 w-24'} flex-shrink-0 rounded-lg bg-gray-50 p-2`}>
        <ImageWithFallback
          src={player.sponsor_image_url}
          alt={player.sponsor_name || `Χορηγός ${player.name}`}
          className="h-full w-full object-contain"
          fallback={
            <div className="flex h-full w-full items-center justify-center text-center text-[10px] font-bold text-gray-400">
              {player.sponsor_name || 'Χορηγός'}
            </div>
          }
        />
      </div>
      <div className="min-w-0 flex-1">
        <p className="text-[10px] font-black uppercase tracking-[0.16em] text-primary-500">
          Χορηγός Παίκτριας
        </p>
        <p className="mt-0.5 truncate text-sm font-black text-gray-900">
          {player.sponsor_name || 'Υποστηρικτής της παίκτριας'}
        </p>
      </div>
      {player.sponsor_url && (
        <SafeIcon
          icon={FiExternalLink}
          className="h-4 w-4 flex-shrink-0 text-gray-400 transition group-hover:text-primary-600"
        />
      )}
    </div>
  );

  return (
    <div className={compact ? 'space-y-2' : 'space-y-3'}>
      {hasSponsor &&
        (player.sponsor_url ? (
          <a
            href={player.sponsor_url}
            target="_blank"
            rel="noopener noreferrer"
            onClick={(event) => event.stopPropagation()}
            aria-label={`Επίσκεψη στον χορηγό ${player.sponsor_name || ''}`}
          >
            {sponsorContent}
          </a>
        ) : (
          sponsorContent
        ))}

      {!hasSponsor && !compact && (
        <div className="flex items-start gap-3 rounded-xl border border-dashed border-primary-200 bg-primary-50/50 p-3 text-primary-800">
          <div className="mt-0.5 flex h-8 w-8 flex-shrink-0 items-center justify-center rounded-full bg-white shadow-sm">
            <SafeIcon icon={FiHeart} className="h-4 w-4" />
          </div>
          <div>
            <p className="text-xs font-black">Αυτή η θέση μπορεί να γράψει το δικό σου όνομα.</p>
            <p className="mt-0.5 text-[11px] leading-relaxed text-primary-700">
              Στήριξε άμεσα τη διαδρομή μιας αθλήτριας του ΑΟ Χανιά.
            </p>
          </div>
        </div>
      )}

      <div onClick={(event) => event.stopPropagation()}>
        <SponsorshipCTA
          player={player}
          sourceLocation={sourceLocation}
          variant="player"
          label="Become a Sponsor"
          className={compact ? 'px-4 py-2.5 text-sm' : ''}
        />
      </div>
    </div>
  );
};

export default PlayerSponsorBlock;